import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

const CognitoCallback = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait for the auth library to process the callback
    if (!auth.isLoading) {
      if (auth.isAuthenticated) {
        // Successfully authenticated, redirect to home
        navigate('/');
      } else if (auth.error) {
        // Authentication failed
        console.error('Auth error:', auth.error);
        navigate('/');
      }
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate]);

  if (auth.isLoading) {
    return <div className="text-center mt-4">Processing login...</div>;
  }

  return <div className="text-center mt-4">Redirecting...</div>;
};

export default CognitoCallback;